import { httpRequest } from '@calendly/http-tools'
import { createAsyncThunk, unwrapResult } from '@reduxjs/toolkit'

import { dealSelector, externalCustomerSelector } from '../selectors'

export const fetchCustomer = createAsyncThunk(
  'deal/fetchCustomer',
  async (_, { getState, rejectWithValue }) => {
    const state = getState()
    const { uuid } = dealSelector(state)
    const customerId = externalCustomerSelector(state)

    if (customerId) return customerId

    const [success, response] = await httpRequest({
      url: `/api/billing/deals/${uuid}/customer`,
      method: 'POST'
    })

    if (!success) {
      return rejectWithValue(response)
    }

    return response.id
  }
)

export const fetchToken = createAsyncThunk(
  'deal/fetchToken',
  async (_, { getState, rejectWithValue }) => {
    const state = getState()
    const { uuid } = dealSelector(state)
    const customerId = externalCustomerSelector(state)

    if (!customerId) return null

    const [success, response] = await httpRequest({
      url: '/api/billing/cert_capture_tokens',
      method: 'POST',
      params: {
        external_customer_id: customerId,
        deal_uuid: uuid
      }
    })

    if (!success) {
      return rejectWithValue(response)
    }

    return response.token
  }
)

export const fetchCustomerCertCaptureToken = () => (dispatch) => {
  dispatch(fetchCustomer())
    .then(unwrapResult)
    .then(() => dispatch(fetchToken()))
}
